import { render, staticRenderFns } from "./ListProcesoElectoralMultimedia.vue?vue&type=template&id=2379278d&scoped=true&"
import script from "./ListProcesoElectoralMultimedia.vue?vue&type=script&lang=js&"
export * from "./ListProcesoElectoralMultimedia.vue?vue&type=script&lang=js&"
import style0 from "./ListProcesoElectoralMultimedia.vue?vue&type=style&index=0&id=2379278d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379278d",
  null
  
)

export default component.exports